import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "reload",
  "use": "reload-usage",
  "viewBox": "0 0 11 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid\" viewBox=\"0 0 11 12\" id=\"reload\"><path d=\"M10.557 6.42h-.954a.447.447 0 0 0-.444.434 3.681 3.681 0 0 1-3.652 3.296c-2.028 0-3.671-1.652-3.671-3.692 0-2.021 1.654-3.663 3.656-3.691v.6c0 .273.193.395.43.273l3.06-1.577c.237-.122.237-.32 0-.442L5.922.047c-.237-.122-.43 0-.43.271v.605C2.475.952 0 3.422 0 6.462 0 9.52 2.465 12 5.507 12 8.417 12 10.8 9.733 11 6.857a.44.44 0 0 0-.443-.437Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol